import { AssetItemAdjustmentBase } from './base/asset-item-adjustment-base';

export class AssetItemAdjustment extends AssetItemAdjustmentBase { }